<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>

    <div
      id="edituser"
      class="modal fade"
      :class="{ show: show }"
      style="background: rgba(0,0,0,0.5)"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" v-click-outside="onCancel" id="modal">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5 class="px-2 mb-0">
                {{ $t("edit_driver") }}
              </h5>
              <p class="cursor-pointer px-2" @click="onCancel">
                <img src="../../assets/images/Vector (1).png" alt="" />
              </p>
            </div>
            <div
              v-if="mssg"
              align="center"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              align="center"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>
            <form class="p-2" @submit.prevent="editdriver">
              <div
                style="display: flex; justify-content: space-between;"
                class="driver_form"
              >
                <div class="driver_form_input">
                  <div class="form-group">
                    <label for="fullname"> {{ $t("driver-name") }}</label>
                    <input
                      type="text"
                      name="name"
                      v-model="fullname"
                      class="form-control"
                      required
                      id="receiver-name"
                      :placeholder="$t('enter-driver-name')"
                    />

                    <div
                      v-show="selectNotification !== ''"
                      class="alert-danger alert-dismissible fade show"
                    >
                      <p>{{ selectNotification }}</p>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="InputNumber"> {{ $t("phone_num") }}</label>
                    <div class="form-group">
                      <input
                        v-model="number"
                        type="tel"
                        class="form-control"
                        required
                        id="phone_number"
                        :placeholder="$t('enter-num')"
                      />
                    </div>
                    <p v-if="ErrorPhone" class="my-0 small text-error p-1">
                      {{ ErrorPhone }}
                    </p>
                  </div>
                </div>

                <div class="driver_form_input">
                  <div class="form-group">
                    <label for="email"> {{ $t("email") }}</label>
                    <input
                      v-model="email"
                      type="text"
                      name="name"
                      class="form-control"
                      required
                      id="email"
                      :placeholder="$t('enter-mail')"
                    />
                  </div>

                  <div class="form-group">
                <label for="address"> {{ $t("address") }}</label>
                <input
                  type="text"
                  name="address"
                  v-model="address"
                  class="form-control"
                  required
                  :placeholder="$t('enter-address')"
                />
              </div>
                </div>
              </div>

              <div style="display: flex; justify-content:right;">
                <button
                  type="submit"
                  class="btn btn-primary btn-edit"
                  :disabled="selectNotification !== ''"
                >
                  {{ $t("save") }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import * as intlTelInput from "../../assets/js/intlTelInput";
import * as utils from "../../assets/js/utils";

export default {
  name: "EditDriver",
  components: {
    Loading,
  },
  props: {
    show: Boolean,
    driver: Array,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,

      fullname: "",
      email: "",
      address: "",
      number: "",
      mssg: "",
      ErrorPhone: "",
      Errormssg: "",
      selectedVehicle: "",
      selectNotification: "",
      iti: "",
    };
  },
  mounted() {
    this.initialiseForm();
  },
  watch: {
    driver: {
      handler() {
        this.initialiseForm();
      },
      deep: true,
    },
    fullname: {
      handler() {
        if (/^[a-zA-Z\s]*$/.test(this.fullname)) {
          this.selectNotification = "";
        } else {
          this.selectNotification = this.$t("must_contain");
        }
      },
    },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    ...mapGetters(["vehicles"]),
  },
  methods: {
    ...mapActions(["editDriver", "getDrivers"]),
    onCancel() {
      this.$emit("closeEditDriverModal");
    },
    initialiseForm() {
      if (this.driver.length === 0) return;

      setTimeout(() => {
        const driver = this.driver[0];
        this.fullname = driver.name;
        var input = document.querySelector("#phone_number");
        this.iti = intlTelInput(input, {
          separateDialCode: true,
          utilsScript: utils,
        });
        var number = "+" + driver.phoneNumber.toString();
        this.iti.setNumber(number);

        this.number = driver.phoneNumber;
        this.email = driver.email;
        this.address = driver.address;
      }, 200);
    },
    editdriver() {
      if (this.driver.length === 0) return;

      let number = this.iti.getNumber();

      this.ErrorPhone = "";
      if (!this.iti.isValidNumber()) {
        this.ErrorPhone = this.$t("valid_phone");
      } else {
        this.isLoading = true;
        this.Errormssg = "";

        number = number.replace(/^\+/, "").replace(/^0+/, "");

        const driver = this.driver[0];
        const newDriver = {
          phoneNumber: number,
          name: this.fullname,
          address: this.address,
          email: this.email,
        };

        this.editDriver({ newDriver, id: driver.id })
          .then((res) => {
            this.getDrivers();
            this.onCancel();

            this.$emit("showSuccessPopup", {
              msg: this.$t("edited_driver_mssg"),
              heading: this.$t("edited_driver_heading"),
            });
            this.isLoading = false;
            this.mssg =
              res.data.message[0].toUpperCase() + res.data.message.slice(1);
          })
          .catch((error) => {
            this.isLoading = false;
            this.Errormssg =
              error.response.data.message[0].toUpperCase() +
              error.response.data.message.slice(1);
            if (error.response) {
              console.error(error.response.data.message);
            }
          });
      }
    },
  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 410px !important;
}

@media (max-width: 767px) {
  .driver_form {
    flex-direction: column;
  }
}

@media (min-width: 768px) {
  .modal-dialog {
    max-width: 500px !important;
  }

  .driver_form_input {
    width: 250px;
  }

  .driver_form {
    gap: 0.7rem;
  }
}
</style>
